module.exports = __webpack_public_path__ + "static/media/mito11.d16face1.jpg";